module.exports = __webpack_public_path__ + "static/media/brand-logo.1657123d.png";


//////////////////
// WEBPACK FOOTER
// ./src/brand-logo.png
// module id = 522
// module chunks = 0